import { createFileRoute } from '@tanstack/react-router';

import { InstructorListPage } from '~pages/instructors/instructor-list-page';

export const Route = createFileRoute(
  '/_auth/_layout/category-config/instructors',
)({
  component: InstructorListPage,
});
